import { BaseRes } from 'types/base';
import request, { ginzaxiaomaApiRequest } from '.';
import { MallCountry } from 'types/home';
import { useEffect, useState } from 'react';

type RateMap = Record<string, number>;

export const getCountryList = () => {
  return request.get<BaseRes<MallCountry[]>>('/home/countries');
};

export const useCountryList = () => {
  const [countryList, setCountryList] = useState<MallCountry[]>([]);

  useEffect(() => {
    getCountryListV2().then((res) => {
      setCountryList(res);
    });
  }, []);

  return { countryList };
};

export const getCountryListV2 = () => {
  return ginzaxiaomaApiRequest.get<MallCountry[]>('/admin/common/country-list');
};

export const getCityListByCountryCode = (
  countryCode: string,
  lang?: string,
) => {
  const headers = lang ? { 'Accept-Language': lang } : undefined;
  return ginzaxiaomaApiRequest
    .get<{
      areaCode: string;
      code: string;
      name: string;
      continent: string;
      cityList: {
        code: string;
        countryCode: string;
        id: string;
        name: string;
      }[];
    }>(
      `/admin/common/country/${countryCode}`,
      headers ? { headers } : undefined,
    )
    .then((data) => ({ data }));
};

export const useCityList = (countryCode?: string, lang?: string) => {
  const [cityList, setCityList] = useState<
    {
      code: string;
      countryCode: string;
      id: string;
      name: string;
    }[]
  >([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!countryCode) return;

    setLoading(true);
    getCityListByCountryCode(countryCode, lang).then((res) => {
      setLoading(false);
      if (!res.data) return;

      const { cityList } = res.data;

      if (cityList) {
        setCityList(cityList);
      }
    });
  }, [countryCode, lang]);

  return { cityList, loading };
};

export const getTodayRateMap = () => {
  return request.get<
    BaseRes<{
      [key: string]: number;
    }>
  >('/home/getTodayRates');
};

export const useTodayRateMap = () => {
  const [todayRateMap, setTodayRateMap] = useState<{ [key: string]: number }>(
    {},
  );

  useEffect(() => {
    getTodayRateMap().then(({ data }) => {
      setTodayRateMap(data);
    });
  }, []);

  return todayRateMap;
};

export const getTodayRateMapV2 = (): Promise<RateMap> => {
  return ginzaxiaomaApiRequest.get<RateMap>('/admin/common/rate/get-rate-map');
};

export const useTodayRateMapV2 = () => {
  const [todayRateMap, setTodayRateMap] = useState<RateMap>({});

  useEffect(() => {
    getTodayRateMapV2().then((data) => {
      setTodayRateMap(data);
    });
  }, []);

  return todayRateMap;
};
